import {Environment} from './environment.type';

export const environment: Environment = {
  ENV: 'prod',
  APP_NAME: 'Compliance Desk',
  BASE_API_URL: 'https://compliance.devteamweb.com.ar/backend/',
  API_PREFIX: 'api/v1/',
  TTL_APP: 24 * 60 * 60,
  TTL_COMPANY: 24 * 60 * 60,
  TTL_AUTH: 24 * 60 * 60
};
